export enum InternalRiskLevelType {
  Prohibited = 1,
  High = 2,
  Medium = 3,
  Low = 4,
}
